import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class ResidenceApi extends QuestionSimpleApi {
    public query(actor: QuestionActor): AnswersRequest {
        const { answersActors, id, responseActor } = actor.getSnapshot().context;
        const { comment } = responseActor.getSnapshot().context;
        return {
            question: id,
            data: answersActors.map((answerActor, idx) => {
                const { id, response } = answerActor.getSnapshot().context;
                const { extra, value } = response.getSnapshot().context;

                return {
                    bool: true,
                    text: value ? String(value) : null,
                    longtext: extra ? String(extra) : null,
                    int: idx + 1,
                    answer: id,
                };
            }),
            comment,
        };
    }

    public validate({ answersActors, params: { required } }: QuestionContext): boolean {
        if (!required) {
            return true;
        }

        return answersActors.every(
            (answerActor) => !!answerActor.getSnapshot().context.response.getSnapshot().context.value,
        );
    }
}
